module.exports = __webpack_public_path__ + "img/sales-force-logo.c3d4c2bd.svg";